export default __webpack_public_path__ + "svg/CompaniesLogos/logo_novalo.svg?95d31c5d";